import { createSelector } from 'reselect';
import { RootState } from 'store/types';

/**
 * Share Medical History
 */
export const shareMedicalHistorySelector = (state: RootState) =>
  state.medicalHistory.shareMedicalHistory;

export const shareMedicalHistorySendingSelector = createSelector(
  shareMedicalHistorySelector,
  shareMedicalHistory => shareMedicalHistory.isSendingMedicalHistory
);

export const shareMedicalHistoryDataSelector = createSelector(
  shareMedicalHistorySelector,
  shareMedicalHistory => shareMedicalHistory.sharedMedicalHistoryData
);

/**
 * Download Medical History
 */
export const medicalHistoryDownloadsSelector = (state: RootState) =>
  state.medicalHistory.downloadMedicalHistory;

export const medicalHistoryDownloadingSelector = createSelector(
  medicalHistoryDownloadsSelector,
  downloadMedicalHistory => downloadMedicalHistory.isDownloading
);
